let productCardInitialized = false;

// Initialize color swatches Swiper
function initColorSwatchesSwiper() {
  document.querySelectorAll(".js-color-swatches-swiper").forEach((swiperEl) => {
    // Skip if already initialized
    if (swiperEl.swiper) return;

    const container = swiperEl.closest(".c-color-swatches-container");
    const prevBtn = container?.querySelector(".c-color-swatches-nav-prev");
    const nextBtn = container?.querySelector(".c-color-swatches-nav-next");

    new Swiper(swiperEl, {
      slidesPerView: "auto",
      spaceBetween: 10,
      slidesPerGroup: 2,
      freeMode: true,
      grabCursor: true,
      watchOverflow: false,
      observer: true,
      observeParents: true,
      // slidesOffsetBefore: 2,
      // slidesOffsetAfter: 2,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "c-color-swatches-nav-disabled",
      },
    });
  });
}

// Initialize on DOM ready
document.addEventListener("DOMContentLoaded", () => {
  initColorSwatchesSwiper();
});

// Re-initialize after collection updates
if (!productCardInitialized) {
  productCardInitialized = true;

  document.addEventListener("collection:updated", () => {
    initColorSwatchesSwiper();
  });
}

initColorSwatchesSwiper();

export { initColorSwatchesSwiper };

// Handle price updates when variant changes in product cards
document.addEventListener("variant:imageChange", (e) => {
  const { productId, priceFormatted, compareAtPriceFormatted } = e.detail;

  // Find the product card for this product
  const card = document.querySelector(
    `.c-product-card-atc[data-product-id="${productId}"]`,
  );
  if (!card) return;

  const priceContainer = card.querySelector(".js-product-card-price");
  if (!priceContainer) return;

  // Update price display
  if (compareAtPriceFormatted) {
    // Sale price
    priceContainer.innerHTML = `
      <span class="price--sale js-price-sale">${priceFormatted}</span>
      <span class="price--compare js-price-compare">${compareAtPriceFormatted}</span>
    `;
  } else {
    // Regular price
    priceContainer.innerHTML = `
      <span class="price--regular js-price-regular">${priceFormatted}</span>
    `;
  }
});

document.addEventListener("click", (e) => {
  const btn = e.target.closest(".c-product-card-atc__button");
  if (!btn) return; // Not our button

  const card = btn.closest(".c-product-card-atc");
  if (!card) return;

  const formWrapper = card.querySelector(".c-product-card-atc__form");
  if (!formWrapper) return;

  const isHidden = formWrapper.hasAttribute("hidden");
  if (isHidden) {
    formWrapper.removeAttribute("hidden");
    card.classList.add("is-open");
    // Initialize swiper when form opens
    setTimeout(() => initColorSwatchesSwiper(), 50);
  } else {
    formWrapper.setAttribute("hidden", "");
    card.classList.remove("is-open");
  }
});
